if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.content = this.querySelector('[role="document"]');
        this.navButtons = this.querySelectorAll('.product-media-modal__nav');

        this.navButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.cycleMedia(Number(button.dataset.direction));
          });
          button.addEventListener('pointerup', (event) => event.stopPropagation());
        });

        this.addEventListener('keyup', (event) => {
          if (event.code === 'ArrowLeft') this.cycleMedia(-1);
          if (event.code === 'ArrowRight') this.cycleMedia(1);
        });

        this.bindSwipe();
      }

      bindSwipe() {
        if (!this.content) return;

        let startX = 0;
        let startY = 0;

        this.content.addEventListener(
          'touchstart',
          (event) => {
            startX = event.changedTouches[0].screenX;
            startY = event.changedTouches[0].screenY;
          },
          { passive: true }
        );

        this.content.addEventListener(
          'touchend',
          (event) => {
            const deltaX = event.changedTouches[0].screenX - startX;
            const deltaY = event.changedTouches[0].screenY - startY;
            if (Math.abs(deltaX) < 50 || Math.abs(deltaX) < Math.abs(deltaY)) return;
            this.cycleMedia(deltaX > 0 ? -1 : 1);
          },
          { passive: true }
        );
      }

      get mediaItems() {
        return Array.from(this.content.querySelectorAll('[data-media-id]')).filter((media, index) => {
          return !media.classList.contains('product__media-item--variant') || index === 0;
        });
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const activeMedia =
          this.content.querySelector(`[data-media-id="${mediaId}"]`) || this.mediaItems[0];
        this.setActiveMedia(activeMedia);
      }

      cycleMedia(direction) {
        const items = this.mediaItems;
        if (items.length < 2) return;

        const currentIndex = items.findIndex((media) => media.classList.contains('active'));
        const nextIndex = (Math.max(currentIndex, 0) + direction + items.length) % items.length;
        this.setActiveMedia(items[nextIndex]);
      }

      setActiveMedia(activeMedia) {
        if (!activeMedia) return;

        this.content.querySelectorAll('[data-media-id]').forEach((media) => {
          media.classList.remove('active');
        });
        activeMedia.classList.add('active');
        window.pauseAllMedia();

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        this.navButtons.forEach((button) => {
          button.hidden = this.mediaItems.length < 2;
        });
      }
    }
  );
}
